// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Sheet } from '@node-space/ui-components'
import { UpdateCryptoPayoutFormErrors } from 'pages/MassPayouts/types'

export interface MassPayoutEditRecordContainerProps {
  isEditPayoutModalVisible: boolean
  onBackHandler: () => void
  children: React.ReactNode
  onCloseModal: () => void
  errors: UpdateCryptoPayoutFormErrors
}

export const MassPayoutEditRecordContainer = ({
  isEditPayoutModalVisible,
  onBackHandler,
  children,
  onCloseModal,
  errors,
}: MassPayoutEditRecordContainerProps) => {
  const { t } = useTranslation()

  return (
    <Sheet
      isOpen={isEditPayoutModalVisible}
      header={t('massPayouts.editPayment')}
      onClose={onCloseModal}
      onBack={onBackHandler}
    >
      <Box flex flexCol width="full">
        <Box flexCol width="full" gapY={16}>
          {children}
        </Box>
      </Box>
    </Sheet>
  )
}
